<template>
  <div>
      <!-- 此页面作为跳转到登录页面的中间页面 -->
  </div>
</template>

<script>
export default {
	name : 'noAuth401',
  data () {
    return {}
  },
  created() {
    // 跳转到登录页面
	localStorage.setItem("bUserinfo", '')
	sessionStorage.setItem("authToken", '');
    this.$router.push({ name: 'Login' });
  }
}
</script>

<style>
</style>